require("./bootstrap");
global.$ = global.jQuery = require("jquery");
import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation, Pagination]);
window.Swiper = Swiper;
